import { ICellRendererParams } from 'ag-grid-community';
import { Label } from 'react-bootstrap';

const ReferralStatusLabel = (params: ICellRendererParams) => {
    let status = params.value;
    let style = 'default';

    switch (status) {
        case 'Pending Center': style = 'warning'; break;
        case 'Center Approved': style = 'success'; break;
        case 'Closed by Patient': style = 'danger'; break;
        case 'Completed by Center': style = 'info'; break;
    }

    return <Label bsStyle={style}>{status}</Label>;
};

export default ReferralStatusLabel;